var FlowStep;
(function (FlowStep) {
    FlowStep["SPINNER"] = "spinner";
    FlowStep["INIT"] = "init";
    FlowStep["CONFIRM"] = "confirm";
    FlowStep["SUBSCRIBE"] = "subscribe";
    FlowStep["ERROR"] = "error";
    FlowStep["FRAUD"] = "fraud";
    FlowStep["SUBSCRIPTION_FAILED"] = "subscription failed";
    FlowStep["SUBSCRIPTION_SUCCEEDED"] = "subscription success";
    FlowStep["SUBSCRIPTION_SUCCEEDED_CONTAINER"] = "subscription success container";
    FlowStep["TIMEOUT"] = "timeout";
    FlowStep["WIFI"] = "wifi";
    FlowStep["CONDITIONAL_CLICK"] = "conditional click";
    FlowStep["OTP_CHALLENGE"] = "otp challenge";
    FlowStep["OTP_VALIDATE"] = "otp validate";
    FlowStep["OTP_SUBMIT"] = "otp submit";
    FlowStep["OTP_VALIDATE_ERROR"] = "otp validate error";
    FlowStep["OTP_SUBMIT_ERROR"] = "otp submit error";
    FlowStep["IDENTIFY_FAILURE"] = "identify failure";
    FlowStep["HIDE_CONTENT_CLICK"] = "hide content click";
    FlowStep["OTP_REDIRECT_BUTTON"] = "otp redirect button";
    //Non standard flow steps
    FlowStep["CONTENT_CLICK"] = "content click";
    FlowStep["HE_OTP_CHALLENGE"] = "he otp challenge";
})(FlowStep || (FlowStep = {}));
export default FlowStep;
